module.exports = __webpack_public_path__ + "img/banner.45beb8cc.png";